// Promote only visible cinematic media; pause offscreen/hidden-page work.
const selector = '.mabe-cinematic,.mabe-hero[data-motion="true"]';
const seen = new WeakSet();
const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
  for (const entry of entries) {
    entry.target.toggleAttribute('data-mabe-motion-visible', entry.isIntersecting);
  }
}, { rootMargin: '40px' }) : null;
function register(root) {
  const elements = [...root.querySelectorAll(selector)];
  if (root.matches?.(selector)) elements.push(root);
  for (const element of elements) {
    if (seen.has(element)) continue;
    seen.add(element);
    if (observer) observer.observe(element);
    else element.setAttribute('data-mabe-motion-visible', '');
  }
}
register(document);
document.addEventListener('shopify:section:load', event => register(event.target));
document.addEventListener('shopify:section:unload', event => {
  for (const element of event.target.querySelectorAll(selector)) observer?.unobserve(element);
});
function updateVisibility() { document.documentElement.style.setProperty('--mabe-page-motion-state', document.hidden ? 'paused' : 'running'); }
document.addEventListener('visibilitychange', updateVisibility);
updateVisibility();
